import { LID_AA_PCM_CHANGE } from "@/lib/drivers/tandem/events/LID_AA_PCM_CHANGE";
import { LID_AA_USER_MODE_CHANGE } from "@/lib/drivers/tandem/events/LID_AA_USER_MODE_CHANGE";
import { LID_ALARM_ACTIVATED } from "@/lib/drivers/tandem/events/LID_ALARM_ACTIVATED";
import { LID_ALERT_ACTIVATED } from "@/lib/drivers/tandem/events/LID_ALERT_ACTIVATED";
import { LID_ARM_INIT } from "@/lib/drivers/tandem/events/LID_ARM_INIT";
import { LID_BASAL_DELIVERY } from "@/lib/drivers/tandem/events/LID_BASAL_DELIVERY";
import { LID_BASAL_RATE_CHANGE } from "@/lib/drivers/tandem/events/LID_BASAL_RATE_CHANGE";
import { LID_BG_READING_TAKEN } from "@/lib/drivers/tandem/events/LID_BG_READING_TAKEN";
import { LID_BOLEX_ACTIVATED } from "@/lib/drivers/tandem/events/LID_BOLEX_ACTIVATED";
import { LID_BOLEX_COMPLETED } from "@/lib/drivers/tandem/events/LID_BOLEX_COMPLETED";
import { LID_BOLUS_ACTIVATED } from "@/lib/drivers/tandem/events/LID_BOLUS_ACTIVATED";
import { LID_BOLUS_COMPLETED } from "@/lib/drivers/tandem/events/LID_BOLUS_COMPLETED";
import { LID_BOLUS_DELIVERY } from "@/lib/drivers/tandem/events/LID_BOLUS_DELIVERY";
import { LID_BOLUS_REQUESTED_MSG1 } from "@/lib/drivers/tandem/events/LID_BOLUS_REQUESTED_MSG1";
import { LID_BOLUS_REQUESTED_MSG2 } from "@/lib/drivers/tandem/events/LID_BOLUS_REQUESTED_MSG2";
import { LID_BOLUS_REQUESTED_MSG3 } from "@/lib/drivers/tandem/events/LID_BOLUS_REQUESTED_MSG3";
import { LID_CANNULA_FILLED } from "@/lib/drivers/tandem/events/LID_CANNULA_FILLED";
import { LID_CARB_ENTERED } from "@/lib/drivers/tandem/events/LID_CARB_ENTERED";
import { LID_CARTRIDGE_FILLED } from "@/lib/drivers/tandem/events/LID_CARTRIDGE_FILLED";
import { LID_CGM_CALIBRATION } from "@/lib/drivers/tandem/events/LID_CGM_CALIBRATION";
import { LID_CGM_CALIBRATION_G7 } from "@/lib/drivers/tandem/events/LID_CGM_CALIBRATION_G7";
import { LID_CGM_CALIBRATION_GX } from "@/lib/drivers/tandem/events/LID_CGM_CALIBRATION_GX";
import { LID_CGM_DATA } from "@/lib/drivers/tandem/events/LID_CGM_DATA";
import { LID_CGM_DATA_G7 } from "@/lib/drivers/tandem/events/LID_CGM_DATA_G7";
import { LID_CGM_DATA_GX } from "@/lib/drivers/tandem/events/LID_CGM_DATA_GX";
import { LID_CGM_DATA_GXB } from "@/lib/drivers/tandem/events/LID_CGM_DATA_GXB";
import { LID_CORRECTION_DECLINED } from "@/lib/drivers/tandem/events/LID_CORRECTION_DECLINED";
import { LID_DAILY_BASAL } from "@/lib/drivers/tandem/events/LID_DAILY_BASAL";
import { LID_DATA_LOG_CORRUPTION } from "@/lib/drivers/tandem/events/LID_DATA_LOG_CORRUPTION";
import { LID_DATE_CHANGED } from "@/lib/drivers/tandem/events/LID_DATE_CHANGED";
import { LID_FACTORY_RESET } from "@/lib/drivers/tandem/events/LID_FACTORY_RESET";
import { LID_HYPO_MINIMIZER_RESUME } from "@/lib/drivers/tandem/events/LID_HYPO_MINIMIZER_RESUME";
import { LID_HYPO_MINIMIZER_SUSPEND } from "@/lib/drivers/tandem/events/LID_HYPO_MINIMIZER_SUSPEND";
import { LID_IDP } from "@/lib/drivers/tandem/events/LID_IDP";
import { LID_IDP_BOLUS } from "@/lib/drivers/tandem/events/LID_IDP_BOLUS";
import { LID_IDP_LIST } from "@/lib/drivers/tandem/events/LID_IDP_LIST";
import { LID_IDP_MSG2 } from "@/lib/drivers/tandem/events/LID_IDP_MSG2";
import { LID_IDP_TD_SEG } from "@/lib/drivers/tandem/events/LID_IDP_TD_SEG";
import { LID_LOG_ERASED } from "@/lib/drivers/tandem/events/LID_LOG_ERASED";
import { LID_NEW_DAY } from "@/lib/drivers/tandem/events/LID_NEW_DAY";
import { LID_PARAM_GLOBAL_SETTINGS } from "@/lib/drivers/tandem/events/LID_PARAM_GLOBAL_SETTINGS";
import { LID_PARAM_PUMP_SETTINGS } from "@/lib/drivers/tandem/events/LID_PARAM_PUMP_SETTINGS";
import { LID_PARAM_REM_SETTINGS } from "@/lib/drivers/tandem/events/LID_PARAM_REM_SETTINGS";
import { LID_PARAM_REMINDER } from "@/lib/drivers/tandem/events/LID_PARAM_REMINDER";
import { LID_PUMPING_RESUMED } from "@/lib/drivers/tandem/events/LID_PUMPING_RESUMED";
import { LID_PUMPING_SUSPENDED } from "@/lib/drivers/tandem/events/LID_PUMPING_SUSPENDED";
import { LID_TEMP_RATE_ACTIVATED } from "@/lib/drivers/tandem/events/LID_TEMP_RATE_ACTIVATED";
import { LID_TEMP_RATE_COMPLETED } from "@/lib/drivers/tandem/events/LID_TEMP_RATE_COMPLETED";
import { LID_TIME_CHANGED } from "@/lib/drivers/tandem/events/LID_TIME_CHANGED";
import { LID_TUBING_FILLED } from "@/lib/drivers/tandem/events/LID_TUBING_FILLED";

export const TandemEvents = {
  // Bolus
  [LID_BOLUS_REQUESTED_MSG1.value]: LID_BOLUS_REQUESTED_MSG1,
  [LID_BOLUS_REQUESTED_MSG2.value]: LID_BOLUS_REQUESTED_MSG2,
  [LID_BOLUS_REQUESTED_MSG3.value]: LID_BOLUS_REQUESTED_MSG3,
  [LID_BOLUS_ACTIVATED.value]: LID_BOLUS_ACTIVATED,
  [LID_BOLUS_COMPLETED.value]: LID_BOLUS_COMPLETED,
  [LID_BOLUS_DELIVERY.value]: LID_BOLUS_DELIVERY,
  [LID_BOLEX_ACTIVATED.value]: LID_BOLEX_ACTIVATED,
  [LID_BOLEX_COMPLETED.value]: LID_BOLEX_COMPLETED,

  // Basal
  [LID_BASAL_RATE_CHANGE.value]: LID_BASAL_RATE_CHANGE,
  [LID_PUMPING_SUSPENDED.value]: LID_PUMPING_SUSPENDED, // Event too
  [LID_PUMPING_RESUMED.value]: LID_PUMPING_RESUMED,

  // Event
  [LID_DAILY_BASAL.value]: LID_DAILY_BASAL,
  [LID_NEW_DAY.value]: LID_NEW_DAY,
  [LID_CARTRIDGE_FILLED.value]: LID_CARTRIDGE_FILLED,
  [LID_TUBING_FILLED.value]: LID_TUBING_FILLED,
  [LID_CANNULA_FILLED.value]: LID_CANNULA_FILLED,
  [LID_ARM_INIT.value]: LID_ARM_INIT,
  [LID_HYPO_MINIMIZER_RESUME.value]: LID_HYPO_MINIMIZER_RESUME,
  [LID_HYPO_MINIMIZER_SUSPEND.value]: LID_HYPO_MINIMIZER_SUSPEND,
  // TODO [LID_ALARM_ACTIVATED.value]: LID_ALARM_ACTIVATED,
  // TODO [LID_ALERT_ACTIVATED.value]: LID_ALERT_ACTIVATED,

  // Closed Loop
  [LID_AA_PCM_CHANGE.value]: LID_AA_PCM_CHANGE,
  [LID_AA_USER_MODE_CHANGE.value]: LID_AA_USER_MODE_CHANGE,

  // CGM
  [LID_CGM_DATA.value]: LID_CGM_DATA,
  [LID_CGM_DATA_G7.value]: LID_CGM_DATA_G7,
  [LID_CGM_DATA_GX.value]: LID_CGM_DATA_GX,
  [LID_CGM_DATA_GXB.value]: LID_CGM_DATA_GXB,

  // TODO CGM Calibration ?
} as const;

export const AllTandemEvents = {
  [LID_AA_PCM_CHANGE.value]: LID_AA_PCM_CHANGE,
  [LID_AA_USER_MODE_CHANGE.value]: LID_AA_USER_MODE_CHANGE,
  [LID_ALARM_ACTIVATED.value]: LID_ALARM_ACTIVATED,
  [LID_ALERT_ACTIVATED.value]: LID_ALERT_ACTIVATED,
  [LID_ARM_INIT.value]: LID_ARM_INIT,
  [LID_BASAL_DELIVERY.value]: LID_BASAL_DELIVERY,
  [LID_BASAL_RATE_CHANGE.value]: LID_BASAL_RATE_CHANGE,
  [LID_BG_READING_TAKEN.value]: LID_BG_READING_TAKEN,
  [LID_BOLEX_ACTIVATED.value]: LID_BOLEX_ACTIVATED,
  [LID_BOLEX_COMPLETED.value]: LID_BOLEX_COMPLETED,
  [LID_BOLUS_ACTIVATED.value]: LID_BOLUS_ACTIVATED,
  [LID_BOLUS_COMPLETED.value]: LID_BOLUS_COMPLETED,
  [LID_BOLUS_DELIVERY.value]: LID_BOLUS_DELIVERY,
  [LID_BOLUS_REQUESTED_MSG1.value]: LID_BOLUS_REQUESTED_MSG1,
  [LID_BOLUS_REQUESTED_MSG2.value]: LID_BOLUS_REQUESTED_MSG2,
  [LID_BOLUS_REQUESTED_MSG3.value]: LID_BOLUS_REQUESTED_MSG3,
  [LID_CANNULA_FILLED.value]: LID_CANNULA_FILLED,
  [LID_CARB_ENTERED.value]: LID_CARB_ENTERED,
  [LID_CARTRIDGE_FILLED.value]: LID_CARTRIDGE_FILLED,
  [LID_CGM_CALIBRATION_G7.value]: LID_CGM_CALIBRATION_G7,
  [LID_CGM_CALIBRATION.value]: LID_CGM_CALIBRATION,
  [LID_CGM_CALIBRATION_GX.value]: LID_CGM_CALIBRATION_GX,
  [LID_CGM_DATA.value]: LID_CGM_DATA,
  [LID_CGM_DATA_G7.value]: LID_CGM_DATA_G7,
  [LID_CGM_DATA_GX.value]: LID_CGM_DATA_GX,
  [LID_CGM_DATA_GXB.value]: LID_CGM_DATA_GXB,
  [LID_CORRECTION_DECLINED.value]: LID_CORRECTION_DECLINED,
  [LID_DAILY_BASAL.value]: LID_DAILY_BASAL,
  [LID_DATA_LOG_CORRUPTION.value]: LID_DATA_LOG_CORRUPTION,
  [LID_DATE_CHANGED.value]: LID_DATE_CHANGED,
  [LID_FACTORY_RESET.value]: LID_FACTORY_RESET,
  [LID_HYPO_MINIMIZER_RESUME.value]: LID_HYPO_MINIMIZER_RESUME,
  [LID_HYPO_MINIMIZER_SUSPEND.value]: LID_HYPO_MINIMIZER_SUSPEND,
  [LID_IDP.value]: LID_IDP,
  [LID_IDP_BOLUS.value]: LID_IDP_BOLUS,
  [LID_IDP_LIST.value]: LID_IDP_LIST,
  [LID_IDP_MSG2.value]: LID_IDP_MSG2,
  [LID_IDP_TD_SEG.value]: LID_IDP_TD_SEG,
  [LID_LOG_ERASED.value]: LID_LOG_ERASED,
  [LID_NEW_DAY.value]: LID_NEW_DAY,
  [LID_PARAM_GLOBAL_SETTINGS.value]: LID_PARAM_GLOBAL_SETTINGS,
  [LID_PARAM_PUMP_SETTINGS.value]: LID_PARAM_PUMP_SETTINGS,
  [LID_PARAM_REM_SETTINGS.value]: LID_PARAM_REM_SETTINGS,
  [LID_PARAM_REMINDER.value]: LID_PARAM_REMINDER,
  [LID_PUMPING_RESUMED.value]: LID_PUMPING_RESUMED,
  [LID_PUMPING_SUSPENDED.value]: LID_PUMPING_SUSPENDED,
  [LID_TEMP_RATE_ACTIVATED.value]: LID_TEMP_RATE_ACTIVATED,
  [LID_TEMP_RATE_COMPLETED.value]: LID_TEMP_RATE_COMPLETED,
  [LID_TIME_CHANGED.value]: LID_TIME_CHANGED,
  [LID_TUBING_FILLED.value]: LID_TUBING_FILLED,
};
